<template lang="pug">
el-row(:gutter="20", v-if="!isRR")
 el-col(v-for="setor in setores",  :key="setor.setor.codigo", :sd="12" :xl="8" :md="12")
  card-setor( v-if="setor.setor.codigo !== 'TECNICO_DE_CAMPO'" :setorWithCount="setor" @click="goToProdutividade(setor.setor.codigo)")
home-RR(v-else)
</template>

<script>
import CardSetor from '@/screens/produtividade/components/CardSetorProdutividade'
import HomeRR from './rr/Home.vue'
import { mapActions } from 'vuex'

export default {

  components: {
    CardSetor,
    HomeRR
  },

  data () {
    return {
      setores: [],
      isRR: process.env.ESTADO === 'rr'
    }
  },

  async created () {
    this.setores = await this.findSetores()
  },

  methods: {
    ...mapActions({
      findSetores: 'produtividade/findSetores'
    }),

    goToProdutividade (setor) {
      this.$router.push({
        name: 'produtividade/setor',
        params: {
          setor
        }
      })
    }
  }

}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/screens/produtividade/Home.vue